// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1d75be2a","156":"94e2f57a","409":"5d8cb543","957":"68a716f2"}[chunkId] + ".chunk.js";
};